<template>
  <pt-active-setting class="pt-active-setting__page"></pt-active-setting>
</template>

<script>
import PtActiveSetting from 'cps/mall-manage/recommend-manage/pt-active-setting/withData'
export default {
  name: 'pt-active-setting__view',
  components: {
    'pt-active-setting': PtActiveSetting
  }
}
</script>
